export const endpoints = {
  queryTechnicians: '/serviceOrder/query/:accountId',
}
